<template>
    <div></div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import translate from '../plugins/translate'

const user = createNamespacedHelpers('user')
const interceptor = createNamespacedHelpers('interceptor')
export default {
    name: 'kndErrorNotify',
    watch:{
        dialog(value){
            if(value) this.notify()
        }
    },
    methods: {
        ...user.mapActions(['setUser']),
        closeError() {
            this.clearError()
        },
        clearError() {
            this.$store.dispatch('interceptor/clearError')
            this.$store.dispatch('interceptor/closeDialog')
        },
        notify(){
            if(this.error.request.status == 401) {
                this.setUser()
                if(this.$route.path != '/'){
                    this.clearError()
                    localStorage.setItem('goTo', this.$route.fullPath)
                    this.$router.push('/')
                } 
            }
            this.$notify.error({
                title: translate('Erro' , 'KndError'),
                message: this.error.response.data.error || this.error.message,
                onClose: this.closeError,
                onClick: this.closeError
            });
        }

    },
    computed: {
        ...interceptor.mapGetters(['error', 'dialog']),
    }
}
</script>
<style scoped>
.v-alert{
    margin-bottom: 0 !important;
}
</style>
